import React from "react";
import PropTypes from "prop-types";
import styles from "./CardSection.module.css";

export default function CardSection({ title, children }) {
  return (
    <div className={styles.myaccount}>
      {title && <h2 className={styles.title}>{title}</h2>}
      {children}
    </div>
  );
}

CardSection.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
};
